import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["title", "src", "allow"]
const _hoisted_2 = { class: "container flex h-full w-full items-center justify-center bg-purple-100 py-36 lg:px-8" }
const _hoisted_3 = { class: "w-full max-w-2xl bg-black px-14 py-10 text-white" }
const _hoisted_4 = { class: "mb-8 mt-4" }
const _hoisted_5 = { class: "ml-2 h-5 w-14 shrink-0" }

import { onMounted, ref } from 'vue';
import services from '@/components/cookies/services';
import LzIcon from '@/components/base/LzIcon.vue';
import events from '@/events';


export default /*#__PURE__*/_defineComponent({
  __name: 'LzYoutube',
  props: {
    title: {},
    youtubeId: {},
    classes: {},
    allow: {},
    consentTitle: {},
    consentDescription: {},
    consentButtonLabel: {}
  },
  setup(__props: any) {

const props = __props;



const consent = ref(false);

onMounted(() => {
    window.addEventListener(`consent-${services.youtube}`, (e: Event) => {
        consent.value = !!(e as CustomEvent).detail.consent;
    });
});

function enableYoutube() {
    events.$emit('enable-cookies', services.youtube);
}

return (_ctx: any,_cache: any) => {
  return (consent.value)
    ? (_openBlock(), _createElementBlock("iframe", {
        key: 0,
        title: _ctx.title,
        class: _normalizeClass(_ctx.classes),
        src: 
            'https://www.youtube.com/embed/' +
            _ctx.youtubeId +
            '?rel=0&modestbranding=1&playsinline=1&info=0'
        ,
        allow: _ctx.allow
      }, "\n    ", 10, _hoisted_1))
    : _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.consentTitle), 1),
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.consentDescription), 1),
            _createElementVNode("button", {
              onClick: enableYoutube,
              class: "group inline-flex items-center justify-center whitespace-normal"
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.consentButtonLabel), 1),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(LzIcon, {
                  name: "arrow",
                  class: "h-6 w-12 stroke-white stroke-2 transition-transform group-hover:translate-x-2"
                })
              ])
            ])
          ])
        ])
      ])
}
}

})